import React, { createContext, useEffect, useState } from "react";

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  // ================= ENV CONFIG =================

  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_ANLOOK_API_BASE_URL
      : process.env.REACT_APP_ANLOOK_API_BASE_URL;

  const baseURL2 = "https://auth.seobix.com/api";

  const appName = process.env.REACT_APP_APP_NAME;

  // Blog API Credentials
  const USERNAME = process.env.REACT_APP_BLOG_API_USERNAME;
  const PASSWORD = process.env.REACT_APP_BLOG_API_PASSWORD;

  // Sales API Basic Auth
  const salesUsername = process.env.REACT_APP_API_AUTH_USERNAME;
  const salesPassword = process.env.REACT_APP_API_AUTH_PASSWORD;

  const basicAuth = "Basic " + btoa(`${salesUsername}:${salesPassword}`);

  // =================  MUTE STATE =================
  const [isMuted, setIsMuted] = useState(
    JSON.parse(localStorage.getItem("isMuted")) || false,
  );

  const toggleMute = () => {
    setIsMuted((prev) => !prev);
  };

  const [unreadOrders, setUnreadOrders] = useState(() => {
    const saved = localStorage.getItem("unreadOrders");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem("unreadOrders", JSON.stringify(unreadOrders));
  }, [unreadOrders]);

  const addUnreadOrder = (order) => {
    setUnreadOrders((prev) => {
      if (order?.orderid) {
        const exists = prev.some((o) => o?.orderid === order?.orderid);
        if (exists) return prev;
      }
      if (order?._uid) {
        const uidExists = prev.some((o) => o?._uid === order?._uid);
        if (uidExists) return prev;
      }
      return [...prev, order];
    });
  };

  const clearUnreadOrders = () => {
    setUnreadOrders([]);
    localStorage.removeItem("unreadOrders");
  };

  // persist in localStorage
  useEffect(() => {
    localStorage.setItem("isMuted", JSON.stringify(isMuted));
  }, [isMuted]);

  // ================= AUTH FUNCTIONS =================

  const login = () => {
    window.location.href = "/login";
  };

  const signUp = () => {
    const productId = "1";

    const base =
      process.env.NODE_ENV === "development"
        ? "http://localhost:3000"
        : "https://www.anlook.com";

    const callbackUrl = `${base}/identity`;

    const redirectUrl = `https://accounts.bumppy.com/?callback=${callbackUrl}&product_id=${productId}&intent=signup`;

    window.location.href = redirectUrl;
  };

  const storedUser = sessionStorage.getItem("user");

  const parsedUser = storedUser ? JSON.parse(storedUser) : null;

  const [user, setUser] = useState(parsedUser);
  // const userID = parsedUser?.userid || null;
  const [userID, setUserID] = useState(parsedUser?.userid || null);

  const [power, setPower] = useState(sessionStorage.getItem("power"));

  const [generatedHTML, setGeneratedHTML] = useState("");
  const [wsConnected, setWsConnected] = useState(false);
  const [showFreeTrialModal, setShowFreeTrialModal] = useState(false);
  // ADD THIS

  const [contacts, setContacts] = useState([]);
  const [contactsFetched, setContactsFetched] = useState(false);

  const [audienceGroups, setAudienceGroups] = useState([]);
  const [audienceFetched, setAudienceFetched] = useState(false);

  const [whatsappNumbers, setWhatsappNumbers] = useState([]);
  const [whatsappFetched, setWhatsappFetched] = useState(false);

  const [chatContacts, setChatContacts] = useState([]);
  const [chatContactsFetched, setChatContactsFetched] = useState(false);

  const openFreeTrialModal = () => {
    setShowFreeTrialModal(true);
  };

  const closeFreeTrialModal = () => {
    sessionStorage.setItem("freeTrialClosed_global", "true");
    setShowFreeTrialModal(false);
  };

  useEffect(() => {
    const hasClosedBefore = sessionStorage.getItem("freeTrialClosed_global");
    if (!hasClosedBefore) {
      const timer = setTimeout(() => {
        setShowFreeTrialModal(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

 useEffect(() => {
  if (!userID || !baseUrl || !basicAuth) return;

  const fetchGlobalData = async () => {
    try {
      const contactsResponse = await fetch(`${baseUrl}/Campaign/v1.0/getContacts`, {
        method: "POST",
        headers: {
          Authorization: basicAuth,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userid: userID,
          pageIndex: "1",
          recordPerPage: "50",
        }),
      });

      if (contactsResponse.ok) {
        const contactsData = await contactsResponse.json();

        if (contactsData?.data) {
          setChatContacts(contactsData.data);
        }
      } else {
        console.warn("getContacts API failed:", contactsResponse.status);
      }
    } catch (error) {
      console.warn("getContacts fetch failed:", error);
    }

    try {
      const audienceResponse = await fetch(
        `${baseUrl}/LeadManagement/getAudienceGroup`,
        {
          method: "POST",
          headers: {
            Authorization: basicAuth,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userid: userID,
          }),
        }
      );

      if (audienceResponse.ok) {
        const audienceData = await audienceResponse.json();

        if (audienceData?.data) {
          setAudienceGroups(audienceData.data);
        }
      } else {
        console.warn("getAudienceGroup API failed:", audienceResponse.status);
      }
    } catch (error) {
      console.warn("getAudienceGroup fetch failed:", error);
    }
  };

  fetchGlobalData();
}, [userID, baseUrl, basicAuth]);

  useEffect(() => {
    if (user?.userid) {
      setUserID(user.userid);
    }
  }, [user]);

  // ================= PROVIDER =================

  return (
    <GlobalContext.Provider
      value={{
        baseUrl,
        baseURL2,
        appName,
        basicAuth,
        USERNAME,
        PASSWORD,
        login,
        signUp,
        user,
        setUser,
        userID,
        setUserID,
        setPower,
        isMuted,
        toggleMute,
        generatedHTML,
        setGeneratedHTML,
        unreadOrders,
        addUnreadOrder,
        clearUnreadOrders,
        wsConnected,
        setWsConnected,
        openFreeTrialModal,
        closeFreeTrialModal,

        contacts,
        setContacts,
        contactsFetched,
        setContactsFetched,

        audienceGroups,
        setAudienceGroups,
        audienceFetched,
        setAudienceFetched,

        whatsappNumbers,
        setWhatsappNumbers,
        whatsappFetched,
        setWhatsappFetched,
        chatContacts,
        setChatContacts,
        chatContactsFetched,
        setChatContactsFetched,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
